import * as actions from './languageActions';

const languageReducers = {
  [actions.LANGUAGE_SELECTED]: (state, { language }) => {
    state.selected = language;
    return state;
  },
};

export default {
  name: 'language',
  reducers: languageReducers,
  persist: {
    key: 'language',
    whitelist: [],
  },
};
